export { default } from "./JoinClass";
